import React from 'react';
import style from './search-hint.scss';

const SearchHint = (props) => {
    return (
        <div className={`${style['search-hint-container']} ${props.customClass||''}`}>
            <div className={style['arrow']}>
                <div className={style['curve']}></div>
                <div className={style['point']}></div>
            </div>
            <div className={style['hint-container']}>
                <img src='https://image1.jdomni.in/jdomni_email/SignupTag_1807191723.png' alt='Image Not Found'/>
                <span className={style['hint']}>{props.hintText || `Enter ${props.showItemSearchProdSer == 'service' ? 'Service' : 'Product'}  Name`}</span>
            </div>
        </div>
    )
}

export default SearchHint;